var _path, _path2, _path3, _path4, _rect, _path5, _rect2, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoKnowlimits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "knowlimits",
    xmlns: "http://www.w3.org/2000/svg",
    width: 142.848,
    height: 17.299,
    viewBox: "0 0 142.848 17.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M4.325,17.482H0V1.1H4.325V7.915c.393-.568.743-1.092,1.092-1.573s.655-.874.874-1.179L9.567,1.1h5.067L8.606,8.657l7.121,8.781H10.135L5.81,12.108,4.281,14.031v3.364Z",
    transform: "translate(0 -0.619)",
    fill: "#6eaa46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M54.29,17.482H49.222l-5.9-9.742v9.742H39V1.1h5.111l5.854,9.742V1.1H54.29Z",
    transform: "translate(-21.963 -0.619)",
    fill: "#6eaa46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M135.9,17.482H131.84l-2.8-9.348-2.8,9.348h-4.019L116.9,1.1h4.543l2.8,9.392,2.8-9.392H131.1l2.752,9.392,2.8-9.392h4.543Z",
    transform: "translate(-65.833 -0.619)",
    fill: "#6eaa46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M187.7,17.482h-10V1.1h1.922V15.778H187.7Z",
    transform: "translate(-100.073 -0.619)",
    fill: "#727272"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 1.922,
    height: 16.338,
    transform: "translate(89.728 0.481)",
    fill: "#727272"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M234.113,17.482h-1.922V3.808L226.73,14.729h-1.747L219.522,3.852V17.482H217.6V1.1h2.49l5.766,11.62L231.579,1.1h2.534Z",
    transform: "translate(-122.543 -0.619)",
    fill: "#727272"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 1.922,
    height: 16.338,
    transform: "translate(114.977 0.481)",
    fill: "#727272"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M279.064,17.482h-1.922V2.8H271.9V1.1h12.406V2.8h-5.242Z",
    transform: "translate(-153.122 -0.619)",
    fill: "#727272"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M301.931,15.471l.917-1.485a11.513,11.513,0,0,0,1.4.961,6.582,6.582,0,0,0,1.442.568,5.752,5.752,0,0,0,1.485.175,5.442,5.442,0,0,0,1.966-.349,3.179,3.179,0,0,0,1.311-1.048,2.648,2.648,0,0,0,.48-1.529,2.526,2.526,0,0,0-.524-1.573,5.578,5.578,0,0,0-1.354-1.048,17.01,17.01,0,0,0-1.791-.83c-.524-.218-1.048-.481-1.573-.7a11.468,11.468,0,0,1-1.442-.874,3.361,3.361,0,0,1-1-1.223,3.564,3.564,0,0,1-.393-1.747A4.393,4.393,0,0,1,303.5,2.5,4.229,4.229,0,0,1,305.338.968,6.452,6.452,0,0,1,308,.4a6.705,6.705,0,0,1,2.053.262,8.721,8.721,0,0,1,2.009.786l-.786,1.573a7.536,7.536,0,0,0-1.616-.7A5.426,5.426,0,0,0,308,2.1a4.376,4.376,0,0,0-1.7.306,2.925,2.925,0,0,0-1.136.874,2.352,2.352,0,0,0-.393,1.354,2.383,2.383,0,0,0,.48,1.442,4.949,4.949,0,0,0,1.267,1c.524.262,1.092.568,1.66.83s1.136.524,1.66.786a7.239,7.239,0,0,1,1.485.961,4.6,4.6,0,0,1,1.092,1.311,4.054,4.054,0,0,1,.393,1.835,4.75,4.75,0,0,1-.7,2.446,4.8,4.8,0,0,1-1.966,1.616,6.935,6.935,0,0,1-2.971.568,8.329,8.329,0,0,1-5.373-1.922",
    transform: "translate(-169.961 -0.225)",
    fill: "#727272"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M86.649,0A8.649,8.649,0,1,0,95.3,8.649,8.641,8.641,0,0,0,86.649,0m0,4.412a4.281,4.281,0,1,1-4.281,4.281,4.288,4.288,0,0,1,4.281-4.281",
    transform: "translate(-43.926)",
    fill: "#6eaa46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKnowlimits);
export default __webpack_public_path__ + "static/media/logo-knowlimits.ebc66b1951d37ca61a40aed37ce745a0.svg";
export { ForwardRef as ReactComponent };